import PropTypes from 'prop-types'
import React from 'react'


const propTypes = {
  output: PropTypes.string,
}
const defaultProps = {
  output: '',
}


const CodeOutput = ({ output }) => (
  <div>
    <h4>Code Output & Errors</h4>
    {(output) && (
      <div className="uk-margin-top">
        <textarea
          data-test-id="code-output-textarea"
          spellCheck="false"
          style={{
            width: 'calc(100% - 30px)',
            height: 350,
            resize: 'none',
            padding: 15,
            background: '#333',
            border: '1px solid #444',
            color: '#EEE',
            font: '11px/normal "Monaco", "Menlo", "Ubuntu Mono", "Consolas", "source-code-pro", monospace',
          }}
          data-uk-htmleditor
          value={output}
          disabled
        />
      </div>
    )}
    <div
      className="uk-margin-top"
      style={{
        padding: 15,
        background: '#333',
        border: '1px solid #444',
        color: '#EEE',
        borderLeft: '3px solid #1e87f0',
      }}
    >
      <div style={{ float: 'left', width: 50 }}>
        <span data-uk-icon="icon: info; ratio: 1.2;" />
      </div>
      <div style={{ float: 'left', width: 'calc(100% - 50px)' }}>
        <h4 className="uk-light" style={{ marginBottom: 10 }}>Tips for getting output</h4>
        <p className="uk-margin-remove">
          For printing debug statements, do not use the browser console for output. This tab will
          act like your development terminal/console.
        </p>
        <p>
          To see compilation errors (e.g. syntax errors), you must interact with the application to
          trigger the output.
        </p>
      </div>
      <div style={{ clear: 'both' }} />
    </div>

  </div>
)

CodeOutput.propTypes = propTypes
CodeOutput.defaultProps = defaultProps

export default CodeOutput
